














































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, MailingListRecord } from '@/api/email.api';
import SearchHeader from '@/components/SearchHeader.vue';
import Pagination from '@/components/Pagination.vue';
import MailingListsModifyDialog from './MailingListsModifyDialog.vue';

@Component({ components: { SearchHeader, Pagination, MailingListsModifyDialog } })
export default class MailingListsPage extends Vue {
  listParam = {
    page: 1,
    page_size: 10,
    query: ''
  };
  listResult: { items: MailingListRecord[]; total: number } = {
    items: [],
    total: 0
  };
  loading = false;

  mounted() {
    this.getItemList();
  }

  async getItemList() {
    try {
      this.loading = true;
      const res = await emailApis.mailingListsList(this.listParam);
      this.listResult = res;
    } catch (error) {
      this.$message.error(`获取邮件列表失败: ${error.message || error}`);
    } finally {
      this.loading = false;
    }
  }

  handleModify(item: MailingListRecord) {
    (this.$refs.modifyDialog as MailingListsModifyDialog).open(item);
  }

  handleModifySuccess() {
    this.getItemList();
  }

  handleSyncToDb() {
    this.$confirm('确定要从邮件服务器同步邮件列表到数据库吗？', '确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        try {
          await emailApis.mailingListsSyncToDb();
          this.$message.success('已经成功同步邮件列表到数据库');
          this.getItemList();
        } catch (error) {
          this.$message.error(`同步失败: ${error.message || error}`);
        }
      })
      .catch(() => {
        // 取消操作
      });
  }

  handleCleanResignedMembers() {
    this.$confirm('确定要清理邮件列表中的离职成员吗？', '确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        try {
          await emailApis.mailingListsCleanResignedMembers();
          this.$message.success('已经成功清理邮件列表中的离职成员');
          this.getItemList();
        } catch (error) {
          this.$message.error(`操作失败: ${error.message || error}`);
        }
      })
      .catch(() => {
        // 取消操作
      });
  }
}
